import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import { Input, Btn } from '../components/Input';
import { IconEye, IconEyeOff } from '../components/Icons';

export default function Login({ onNavigateRegister, onNavigateForgot }) {
  const { login } = useAuth();
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [haslo, setHaslo] = useState('');
  const [showHaslo, setShowHaslo] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, haslo);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--bg)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px',
    }}>
      <div style={{ width: '100%', maxWidth: '380px' }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <h1 style={{
            fontSize: '28px',
            fontWeight: 800,
            color: 'var(--acc2)',
            letterSpacing: '-0.02em',
            marginBottom: '6px',
          }}>
            ScanPilots
          </h1>
          <p style={{ fontSize: '12px', color: 'var(--ink3)', fontWeight: 500 }}>
            {t('auth.tagline')}
          </p>
        </div>

        {/* Card */}
        <div className="ds-card" style={{ padding: '28px 24px' }}>
          <h2 style={{ fontSize: '14px', fontWeight: 700, color: 'var(--ink)', marginBottom: '20px' }}>
            {t('auth.login')}
          </h2>

          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
            <Input
              label={t('auth.email')}
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder={t('auth.emailPlaceholder')}
              required
              autoFocus
            />
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
                <label style={{ fontSize: '9px', fontWeight: 600, letterSpacing: '0.07em', textTransform: 'uppercase', color: 'var(--ink3)' }}>{t('auth.password')}</label>
                <button type="button" onClick={onNavigateForgot}
                  style={{ background: 'none', border: 'none', color: 'var(--ink3)', fontSize: '10px', cursor: 'pointer', padding: 0 }}
                  onMouseEnter={e => e.target.style.color = 'var(--acc2)'}
                  onMouseLeave={e => e.target.style.color = 'var(--ink3)'}>
                  {t('auth.forgotPasswordLink')}
                </button>
              </div>
              <div style={{ position: 'relative' }}>
                <input
                  type={showHaslo ? 'text' : 'password'}
                  value={haslo}
                  onChange={e => setHaslo(e.target.value)}
                  placeholder={t('auth.passwordMin')}
                  required
                  className="ds-input"
                  style={{ width: '100%', paddingRight: '40px' }}
                />
                <button type="button" onClick={() => setShowHaslo(v => !v)}
                  aria-label={showHaslo ? 'Ukryj hasło' : 'Pokaż hasło'}
                  style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--ink3)', display: 'flex', alignItems: 'center', padding: '2px' }}>
                  {showHaslo ? <IconEyeOff className="w-4 h-4" /> : <IconEye className="w-4 h-4" />}
                </button>
              </div>
            </div>

            {error && (
              <div style={{
                padding: '10px 12px',
                background: 'rgba(176,88,72,0.12)',
                border: '1px solid rgba(176,88,72,0.3)',
                borderRadius: '8px',
                fontSize: '11px',
                color: 'var(--err2)',
              }}>
                {error}
              </div>
            )}

            <Btn
              type="submit"
              variant="primary"
              disabled={loading}
              style={{ width: '100%', padding: '10px 14px', fontSize: '11px', marginTop: '4px' }}
            >
              {loading ? t('auth.loggingIn') : t('auth.login')}
            </Btn>
          </form>
        </div>

        {/* Register link */}
        <p style={{
          textAlign: 'center',
          marginTop: '16px',
          fontSize: '11px',
          color: 'var(--ink3)',
        }}>
          {t('auth.noAccount')}{' '}
          <button
            onClick={onNavigateRegister}
            style={{
              background: 'none',
              border: 'none',
              color: 'var(--acc2)',
              fontWeight: 600,
              cursor: 'pointer',
              fontSize: '11px',
              padding: 0,
            }}
          >
            {t('auth.register')}
          </button>
        </p>
      </div>
    </div>
  );
}
